export const adItems = [
  { type: 'marquee', textKey: 'ad_marquee_community', default: 'Join the Gonkle community • Find your tribe • Sport connects us all' },
  { type: 'image', src: '/ads/cold-drink.jpeg' },
  { type: 'marquee', textKey: 'ad_marquee_movement', default: 'Be part of the movement • Real sports • Real people • Real connections' },
  { type: 'image', src: '/ads/x1.jpeg' },
  { type: 'marquee', textKey: 'ad_marquee_connect', default: 'Connect with athletes • Share your passion • Build friendships through sport' },
  { type: 'image', src: '/ads/x2.jpg' },
  { type: 'marquee', textKey: 'ad_marquee_powered', default: 'Powered by athletes • Made for community • Built with passion' },
  { type: 'image', src: '/ads/x3.jpg' },
  { type: 'image', src: '/ads/x4.jpeg' },
];
